import { render, staticRenderFns } from "./InterfaceAds.vue?vue&type=template&id=b234bcd2&scoped=true&"
var script = {}
import style0 from "./InterfaceAds.vue?vue&type=style&index=0&id=b234bcd2&lang=scss&scoped=true&"
import style1 from "./InterfaceAds.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b234bcd2",
  null
  
)

export default component.exports